import NewsletterBanner from './NewsletterBanner';

export default function NewsletterBannerSmall() {
  return <NewsletterBanner variant="small" />;
}
